import React, { useEffect } from 'react'
import AssemblersTable from '../assemblers/AssemblersTable'
import CouriersTable from '../couriers/CouriersTable'
import OperatorsTable from '../operators/OperatorsTable'
import SupervisorsTable from '../supervisors/SupervisorsTable'
import BrandManagersTable from '../brandManagers/BrandManagersTable'
import CommonErrorDisplay from '@components/common/CommonErrorDisplay'
import CommonTopMenu, { TopMenuElement } from '@components/common/CommonTopMenu'
import CommonSubTopMenu from '@components/common/subTopMenu/CommonSubTopMenu'
import { generatePath } from 'react-router-dom'
import { ROUTE_USERS_MANAGEMENT, ROUTE_USERS_MANAGEMENT_ADD } from '@@partner:config/routes'
import { usePartner } from '@@partner:helpers/hooks/auth'
import { AddOutline, PulseOutline } from 'react-ionicons'

export type UserStructure = 'assemblers' | 'couriers' | 'operators' | 'supervisors' | 'brandManagers'

type ComponentConfig = {
  icon?: React.ReactNode
  title: string
  type: UserStructure
  hideOnTopMenu?: boolean
  component: React.FC<any>
  subPages?: {
    icon: React.ReactNode
    title: string
    to: string
    toParams?: Record<string, string>
  }[]
}

const componentsMap: Record<string, ComponentConfig> = {
  assemblers: {
    title: 'Сборщики',
    type: 'assemblers',
    component: AssemblersTable,
    subPages: [
      {
        icon: <AddOutline />,
        title: 'Добавить сборщика',
        to: ROUTE_USERS_MANAGEMENT_ADD,
        toParams: {
          type: 'assemblers'
        }
      }
    ]
  },
  couriers: {
    title: 'Курьеры',
    type: 'couriers',
    component: CouriersTable,
    subPages: [
      {
        icon: <AddOutline />,
        title: 'Добавить курьера',
        to: ROUTE_USERS_MANAGEMENT_ADD,
        toParams: {
          type: 'couriers'
        }
      }
    ]
  },
  operators: {
    title: 'Операторы',
    type: 'operators',
    component: OperatorsTable,
    subPages: [
      {
        icon: <AddOutline />,
        title: 'Добавить оператора',
        to: ROUTE_USERS_MANAGEMENT_ADD,
        toParams: {
          type: 'operators'
        }
      }
    ]
  },
  supervisors: {
    title: 'Супервайзеры',
    type: 'supervisors',
    component: SupervisorsTable,
    subPages: [
      {
        icon: <AddOutline />,
        title: 'Добавить супервайзера',
        to: ROUTE_USERS_MANAGEMENT_ADD,
        toParams: {
          type: 'supervisors'
        }
      }
    ]
  },
  brandManagers: {
    title: 'Администраторы',
    type: 'brandManagers',
    component: BrandManagersTable,
    subPages: [
      {
        icon: <AddOutline />,
        title: 'Добавить администратора',
        to: ROUTE_USERS_MANAGEMENT_ADD,
        toParams: {
          type: 'brandManagers'
        }
      }
    ]
  }
}

export interface UsersManagementTableProps {
  type: string
  onChangePage?: (title: string) => void
}

export default function UsersManagementTable ({
  type = 'none',
  onChangePage
}: UsersManagementTableProps) {
  const { brandSlug } = usePartner()
  const { component: Component = null, title,  subPages } = componentsMap?.[type] ?? {}

  const topMenuElements: TopMenuElement[] = Object.entries(componentsMap)
    .filter(([ key, { hideOnTopMenu } ]) => !hideOnTopMenu)
    .map(([ key, { icon, title } ]) => ({
      icon,
      to: generatePath(ROUTE_USERS_MANAGEMENT, {
        type: key
      }),
      title
    }))


  useEffect(() => {
    if (title && onChangePage) {
      onChangePage(title)
    }
    else {
      onChangePage?.('Маркетинг')
    }
  }, [ title, onChangePage ])

  if (!type) {
    return (
      <div>
        <CommonTopMenu elements={topMenuElements} />
      </div>
    )
  }
  
  if (!Component) {
    return (
      <CommonErrorDisplay
        title="Ошибка загрузки компонента"
        error={
          new Error(`Компонент для отображения запроса ${type} не найден!`)
        }
      />
    )
  }

  return (
    <div>
      <CommonTopMenu elements={topMenuElements} />
      { subPages && subPages.length > 0 ? (
        <CommonSubTopMenu
          elements={subPages}
        />
      ) : null }
      <Component />
    </div>
  )
 
}
